// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetOrganisationRequestModel from '../../model/get-organisation-request-model';
import GetOrganisationRequestDTO from '../dto/get-organisation-request-dto';
import dtoSchema from '../schemas/get-organisation-request-schema';

export default abstract class GetOrganisationRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetOrganisationRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetOrganisationRequestDTO>): GetOrganisationRequestModel;
  static toModel(dto: DeepPartial<GetOrganisationRequestDTO> | undefined | null): GetOrganisationRequestModel | undefined;
  static toModel(dto: DeepPartial<GetOrganisationRequestDTO> | undefined | null): GetOrganisationRequestModel | undefined {
    return dto ? new GetOrganisationRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetOrganisationRequestModel> | GetOrganisationRequestModel): GetOrganisationRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetOrganisationRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetOrganisationRequestModel, can not map to GetOrganisationRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
